import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Input, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axiosInstance from '../../../utils/axiosConfig';

const AddIndentModal = ({ open, onClose, onAdd, batchId }) => {
  const [indents, setIndents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (open) {
      fetchIndents();
    }
  }, [open]);

  const fetchIndents = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/batch-indents/available-indents');
      // Ensure we have valid data before setting state
      if (Array.isArray(response.data)) {
        setIndents(response.data);
      } else {
        console.error('Invalid response data:', response.data);
        setIndents([]);
      }
    } catch (error) {
      console.error('Error fetching indents:', error);
      message.error('Failed to fetch indents');
      setIndents([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async (indentId) => {
    try {
      await axiosInstance.post(`/batch-indents/${batchId}/indents`, {
        indentId
      });
      message.success('Indent added to batch successfully');
      onAdd();
    } catch (error) {
      console.error('Error adding indent to batch:', error);
      message.error('Failed to add indent to batch');
    }
  };

  const filteredIndents = indents.filter(indent => {
    if (!indent || !indent.IndentID) return false;
    return indent.IndentID.toString().toLowerCase().includes(searchText.toLowerCase());
  });

  const columns = [
    {
      title: 'Indent ID',
      dataIndex: 'IndentID',
      key: 'IndentID',
      render: (text) => text || 'N/A',
    },
    {
      title: 'Created Date',
      dataIndex: 'CreationDate',
      key: 'CreationDate',
      render: (date) => date ? new Date(date).toLocaleString() : 'N/A',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button 
          type="primary" 
          onClick={() => handleAdd(record.IndentID)}
          disabled={!record.IndentID}
        >
          Add
        </Button>
      ),
    },
  ];

  return (
    <Modal
      title="Add Indent to Batch"
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="Search by indent ID"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 200 }}
        />
      </div>
      <Table
        columns={columns}
        dataSource={filteredIndents}
        loading={loading}
        rowKey="IndentID"
        locale={{
          emptyText: 'No indents available to add'
        }}
      />
    </Modal>
  );
};

export default AddIndentModal; 